"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Spinner_1 = __importDefault(require("../Spinner"));
var styles_1 = require("./styles");
// tslint:disable-next-line: max-line-length
var Button = function (_a) {
    var children = _a.children, className = _a.className, isHidden = _a.isHidden, onClick = _a.onClick, isDisabled = _a.isDisabled, style = _a.style, isCircular = _a.isCircular, isLoading = _a.isLoading, type = _a.type;
    var Styled;
    var handleClick = function () { return onClick && onClick(); };
    if (isHidden)
        return null;
    var classNames = (className ? className : '') + " " + (isCircular ? 'circular' : '');
    var content = isLoading ? react_1.default.createElement(Spinner_1.default, { className: "button" }) : children;
    switch (type) {
        case 'secondary':
            Styled = styles_1.Secondary;
            break;
        case 'tertiary':
            Styled = styles_1.Tertiary;
            break;
        default:
            Styled = styles_1.Primary;
    }
    return (react_1.default.createElement(Styled, { type: "button", className: classNames, onClick: handleClick, disabled: isDisabled || isLoading, style: style }, content));
};
exports.default = Button;
//# sourceMappingURL=index.js.map